export default __webpack_public_path__ + "static/media/AelfrithCampMap.a885e349.jpg";